var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhatsapp = function SvgWhatsapp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-2);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 224.9,
    y1: -35,
    x2: -9.4,
    y2: 218.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 224.5,
    y1: -35.3,
    x2: -9.7,
    y2: 217.9,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100,0C44.9,0,0,44.9,0,100s5.2,37.1,15.1,52.9c-3.9,13.8-11.1,40-11.2,40.3-.4,1.4,0,2.8,1,3.8,1,1,2.5,1.3,3.8.9l39.6-12.2c15.5,9.4,33.3,14.3,51.5,14.3,55.1,0,100-44.9,100-100S155.1,0,100,0ZM100,192.3c-17.4,0-34.3-4.9-49-14-.6-.4-1.3-.6-2-.6s-.8,0-1.1.2l-34.6,10.7c2.5-9.3,7.1-25.9,9.8-35.1.3-1.1.1-2.2-.5-3.2-9.7-14.9-14.9-32.3-14.9-50.2C7.7,49.1,49.1,7.7,100,7.7s92.3,41.4,92.3,92.3-41.4,92.3-92.3,92.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M165.3,123.6c-7.1-3.9-13.1-7.9-17.6-10.8-3.4-2.2-5.8-3.8-7.6-4.7-5-2.5-8.8-.7-10.2.7-.2.2-.3.4-.5.6-5.2,7.8-11.9,15.2-13.9,15.6-2.3-.4-13-6.4-23.6-15.3-10.9-9.1-17.7-17.7-18.7-23.6,7-7.2,9.5-11.7,9.5-16.8s-12.4-27.4-14.6-29.6c-2.2-2.2-7.3-2.6-15-1-.7.1-1.4.5-2,1-.9.9-22.8,23.2-12.4,50.3,11.4,29.7,40.7,64.1,78,69.7,4.2.6,8.2,1,11.9,1,22,0,34.9-11.1,38.6-33,.3-1.6-.5-3.2-1.9-4ZM117.9,152c-39.5-5.9-64.3-45-72-64.9-7.6-19.7,6.4-37.3,9.9-41.2,2.9-.5,5.9-.7,7.1-.5,2.6,3.6,11.7,20.8,12.1,23.9,0,2-.7,4.8-8.5,12.7-.7.7-1.1,1.7-1.1,2.7,0,20.1,42.5,48.1,50,48.1s15.1-11,19.9-18.2c.3,0,.8.1,1.4.4,1.4.7,3.8,2.3,6.8,4.2,4,2.6,9.3,6.1,15.6,9.7-2.9,13.7-10.8,27.6-41.3,23Z"
  })));
};
export default SvgWhatsapp;